import { gqlHandleError } from "@/services/graphqlEndPointCommonSetting/graphqlErrorHandler";
import { getGraphqlClient } from "@/services/graphqlEndPointCommonSetting/gqlClient";
export async function wrapGqlRequest(
  queryOrMutation,
  variables = {},
  operationName = "",
) {
  const excludedOperations = ["generateCustomerToken", "createCustomerV2", "resetPassword", "requestPasswordResetEmail"];

  let passAuthHeader = excludedOperations.includes(operationName);

  const client = getGraphqlClient({ passAuthHeader: !passAuthHeader });
  try {
    const isMutation = /^\s*mutation\b/i.test(queryOrMutation);
    const op = isMutation
      ? client.mutation(queryOrMutation, variables)
      : client.query(queryOrMutation, variables);
    const response = await op.toPromise();
    if (response.error) {
      await gqlHandleError(response.error, variables, client.url);
    }
    return operationName && response.data
      ? response.data[operationName]
      : response.data;
  } catch (error) {
    await gqlHandleError(error, variables, client.url);
  }
}
